package com.example.crashbit

import androidx.compose.runtime.Composable

@Composable
actual fun LocalizedApp(languageCode: String, content: @Composable () -> Unit) {
    content()
}

actual val isHapticsSupported: Boolean = false
actual val isSaveSupported: Boolean = false

actual fun toggleFullscreen() {
    js("if (typeof toggleFullscreen === 'function') { toggleFullscreen(); }")
}
